<template>
    <div class="privace-page">
        <div class="main-section">
            <p style="margin: 0">您的信任对我们非常重要，我们深知个人信息对您的重要性，我们将按法律法规要
                求，采取相应安全保护措施，尽力保护您的个人信息安全可控。有鉴于此，昆山春苗网络技术有限公司
                （或简称“我们”）制定本《隐私政策》（下称“本政策”）并提醒您： </p>

            <p>本政策适用于卓师兄恢复大师产品及服务，在使用卓师兄恢复大师产品或服务前，请您务必仔细阅读并透彻
                理解本政策，在确认充分理解并同意后使用相关产品或服务。一旦您开始使用卓师兄恢复大师产品或服务
                ，即表示您已充分理解并同意本政策。如您对本政策内容有任何疑问、意见或建议，可以通过发送邮件至
                邮箱【kf_apps@163.com】的方式与我们联系。</p>

            <h1>一、个人信息的收集</h1>

            <p>我们会出于本政策所述的以下目的，收集您的个人信息： </p>

            <p>1.1 帮助您成为卓师兄恢复大师的用户您需要填写或提交一些必要的信息，如法律法规、规章、规范性文
                件（以下称“法律法规”）规定的需要填写的手机号码、联系方式等方能成为卓师兄恢复大师的注册用户。
                如您提交的信息不完整或不符合法律法规的规定，则您可能无法成为卓师兄恢复大师的注册用户。</p>

            <p>1.2 帮助您更好的使用卓师兄恢复大师服务 </p>

            <p>（1）在服务使用过程中，您可以对卓师兄恢复大师产品及服务的体验问题反馈，帮助我们更好地了解您使
                用我们产品或服务的体验和需求，改善我们产品或服务；</p>

            <p>（（2）在服务使用过程中，您提交订单时将会向卓师兄恢复大师提交手机号码、邮箱、腾讯QQ号码等便于
                我们更好的向您服务的联系方式，如联系方式提交错误，将导致我们无法与您联络；</p>

            <p>（3）我们会收集关于您使用卓师兄恢复大师产品、服务以及使用方式的信息并将这些信息进行关联，帮助
                我们更好的改进产品体验，为您提供更好的服务；</p>

            <p>（4）我们的一些服务需要付费才能使用，当您需要使用这些付费服务时，您需要提供您的银行卡信息及/或
                绑定支付宝、腾讯微信等支付服务，以便我们了解您的支付状态。</p>

            <h1>二、个人信息的保护、使用、共享</h1>

            <p>2.1 对于您在卓师兄恢复大师提交的所涉及包括个人真实姓名、电话、电子邮件、通信地址等在内的用户
                个人信息、第三方平台账号信息等个人隐私信息卓师兄恢复大师承诺均予以严格保密。</p>

            <p>2.2 卓师兄恢复大师将采取技术措施和其他必要措施，确保用户个人隐私信息安全，防止在本服务中收集
                的用户个人隐私信息泄露、毁损或丢失。在发生前述情形或者卓师兄恢复大师发现存在发生前述情形的可
                能时，将及时采取补救措施。</p>

            <p>2.3 卓师兄恢复大师可能会与第三方合作向用户提供相关的服务，在此情况下，如该第三方同意承担与
                卓师兄恢复大师同等的保护用户隐私的责任，则卓师兄恢复大师可将用户的注册资料等提供给该第三方。 </p>

            <p>用户一旦使用第三方平台账号注册、登录、使用卓师兄恢复大师服务的，卓师兄恢复大师对该第三方平台记
                录信息的任何使用，均被视为已经获得了用户本人的完全同意并接受。</p>

            <p>卓师兄恢复大师未经您同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除外：</p>

            <p>（1）卓师兄恢复大师根据司法机关或行政机关基于法定程序要求提供的；</p>

            <p>（2）由于用户将其个人隐私信息告知他人或与他人共享个人隐私信息，由此导致的任何个人信息的泄漏，
                或其他非因卓师兄恢复大师原因导致的个人隐私信息的泄露；</p>

            <p>（3）您自行向第三方公开个人隐私信息；</p>

            <p>（4）任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露。</p>

            <p>2.5 用户同意卓师兄恢复大师可在以下事项中使用用户的个人隐私信息：</p>

            <p>（1）卓师兄恢复大师向用户及时发送重要通知，如个人服务信息、本协议条款的变更；</p>

            <p>（2）卓师兄恢复大师内部进行审计、数据分析和研究等，以改进卓师兄恢复大师的产品、服务和与用户之间的沟通；</p>

            <p>（3）在卓师兄恢复大师运营商——昆山春苗网络技术有限公司旗下软件内部共享，以向您提供昆山春苗网络技术有限公司旗下软件的优惠服务；</p>

            <p>（4）依本协议约定，卓师兄恢复大师管理、审查用户信息及进行处理措施；</p>

            <p>（5）适用法律法规规定的其他事项。</p>

            <h1>三、数据删除及注销</h1>

            <p>您可以申请注销卓师兄恢复大师账户，如您需要注销账户，可以通过发送电子邮件的方式进行注销申请，
                注销完成后，我们将停止为您提供产品与服务，并依据您的要求，除法律法规另有规定外，我们将删除您
                的个人信息。</p>

            <h1>四、联系我们</h1>

            <p>如果您对卓师兄恢复大师的隐私保护政策或数据处理有任何疑问、意见、建议，均可以通过发送电子邮件至
                【kf_apps@163.com】的方式与我们联系，一般情况下，我们将在收到您相关联系信息后三十天内回复。</p>

        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    metaInfo: {
        title: '卓师兄恢复大师', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '卓师兄恢复大师'
        },{                 // set meta
          name: 'description',
          content: '卓师兄恢复大师'
        }]
    },
    data(){
        return{
            
        }
    },
    mounted(){

    },
    created(){
        
    },
    methods:{
        
    },
    components:{
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/base.scss';
.privace-page {
    padding-bottom: 10px;
    .main-section{
        padding:20px 20px 0;
    }
    .main-section > h1 {
        color: #262626;
        font-size: 18px;
        font-weight: bold;
        margin-top: 20px; 
    }
    .main-section > p {
        font-size: 14px;
        color: #262626;
        line-height: 21px;
        margin-top: 16px;
    }
}
</style>



// WEBPACK FOOTER //
// src/static/majia01/Privacy.vue